import styled from 'styled-components';

const H2 = styled.h2`
  font-size: 1.5em;
  font-weight: bold;
`;

export default H2;



// WEBPACK FOOTER //
// ./app/components/H2/index.js